import { Box } from '@mui/material';
import { type JSX, useState } from 'react';

import { Alert } from 'Components/Alert/Alert';
import { Button } from 'Components/Buttons/Buttons';
import { FormFieldDatePicker } from 'Components/FormField/FormFieldDatePicker/FormFieldDatePicker';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { DateFilterHookValues } from 'Hooks/DateFilter';
import { DateOptionSelectOption } from 'Models/Dashboards';

import styles from './CustomDateRangeModal.module.css';

export interface CustomDateRangeModalProps {
    dateFilterHookValues: DateFilterHookValues;
    hideModal: () => void;

    datesRestriction?: 'pastDatesOnly' | 'futureDatesOnly';
}

/** Must be used with `useDateFilter`. */
export const CustomDateRangeModal = (props: CustomDateRangeModalProps): JSX.Element => {
    const [startDate, setStartDate] = useState<Date | undefined>(props.dateFilterHookValues.selection.dateRange.startDate);
    const [endDate, setEndDate] = useState<Date | undefined>(props.dateFilterHookValues.selection.dateRange.endDate);
    const [failureMessage, setFailureMessage] = useState<string>();

    const setCustomDate = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!startDate || !endDate) {
            setFailureMessage('Select both a start date and an end date.');
        } else if (startDate >= endDate) {
            setFailureMessage('The end date must come after the start date.');
        } else {
            setFailureMessage(undefined);
            props.dateFilterHookValues.updateSelection({ option: DateOptionSelectOption.CUSTOM, dateRange: { startDate, endDate } });
            props.hideModal();
        }
    };

    return (
        <Modal open header="Choose a Custom Date">
            {failureMessage && <Alert type="error">{failureMessage}</Alert>}
            <Box component="form" onSubmit={setCustomDate}>
                <div className={styles.dateContainer}>
                    <FormFieldDatePicker formFieldLabel="Start Date" formFieldId="startDate" dateFormat="MM/dd/yyyy" handleChange={setStartDate} selected={startDate} datesRestriction={props.datesRestriction} />
                    <FormFieldDatePicker formFieldLabel="End Date" formFieldId="endDate" dateFormat="MM/dd/yyyy" handleChange={setEndDate} selected={endDate} datesRestriction={props.datesRestriction} />
                </div>
                <div className={styles.modalFormButtonContainer}>
                    <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                        Close
                    </Button>
                    <Button variant="submit">Save</Button>
                </div>
            </Box>
        </Modal>
    );
};
